<template>
<div class="large-container">
	<div>
		<a href="/pc/trainee/downloadCancelRenewUserTemplate">下载模板</a>
		<UploadFile 
			@on-success="getData"
			btn-text="导入"
			:data="{companyId:id}"
			url="/pc/trainee/importCancelRenewUser"
			class="uploadBtn" 
		/>
		<span style="float: right;line-height: 30px;font-size: 14px;">不再续保条件：导入人员的【保障状态】为“保障中”或“待生效”，且【是否续保】为“是”</span>
	</div>
	<div class="mt15">
        <Table :columns="columns" :data="tableData" border >
            <template slot-scope="{ row, index }" slot="msg">
                <span :style="{color:row.success?'#333':'red'}">{{row.success?'校验通过':row.msg}}</span>
            </template>
        </Table>
	</div>
	<div class="center mt20">
		<Button @click="back">返回</Button>
		<Button type="primary" :disabled="!enable" @click="toUpload">确认上传</Button>
	</div>
</div>
</template>
<script>
import UploadFile from '@/pages/haierProduct/components/common/UploadFile'
export default {
	components: { UploadFile },
	data () {
		return {
            tableData:[],
            columns:[
				{title: '校验结果',slot: 'msg',minWidth:220},
				{title: '姓名',key: 'insurantName',width:110},
				// {title: '性别',key: 'insurantGenderName',width:65},
				{title: '证件类型',key: 'insurantIdType',width:95},
				{title: '证件号码',key: 'insurantIdNumber',minWidth:190},
			],
			id:this.$route.params.id,
			pass:false,
		}
	},
	computed:{
		enable () {
			for(let i=0;i<this.tableData.length;i++){
				if(!this.tableData[i].success){
					return false
				}
			}
			return this.tableData.length>0
		}
	},
	methods:{
		/*获取上传数据*/
		getData (res) {
			this.tableData = res.data;
		},
		/*去上传*/
		toUpload () {
			this.$axios.post('/trainee/doImportCancelRenewUser.json',this.tableData).then(res=>{
				this.toast('提交成功')
				setTimeout(()=>{
					this.$router.back()
				},2000)
			})
		},
		back(){
            this.$router.back()
        }
	}
}
</script>
<style scoped lang="less">
.uploadBtn{
    display: inline-block;
    margin-left: 20px;
}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/traineeEmployer/detail/ImportPersonNotRe.vue